import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { getNavItems } from 'selectors/navigation/mainNav';
import { updateNavigation } from 'actions/navigation';

import MainNav from './MainNav';

export const mapStateToProps = state => ({
  navItems: getNavItems(state),
});

const mapDispatchToProps = {
  updateNavigation,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(MainNav);
